module.exports = __webpack_public_path__ + "static/img/bg.276658a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/bg.png
// module id = yM6R
// module chunks = 1